module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "components-container"
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuCode", $$v)
      },
      expression: "queryForm.stuCode"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "行政班名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleFilter.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.queryForm.className),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "className", $$v)
      },
      expression: "queryForm.className"
    }
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "placeholder": "状态"
    },
    model: {
      value: (_vm.queryForm.stuState),
      callback: function($$v) {
        _vm.$set(_vm.queryForm, "stuState", $$v)
      },
      expression: "queryForm.stuState"
    }
  }, _vm._l((_vm.comboData.stuState), function(item) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "label": item.comboName,
        "value": item.comboValue
      }
    })
  }), 1), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleFilter
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), (_vm.operateButtonVisible) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showGraduateRequire
    }
  }, [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v(" 毕业要求")]) : _vm._e(), _vm._v(" "), (_vm.operateButtonVisible) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.initStuRec
    }
  }, [_c('i', {
    staticClass: "el-icon-document-add"
  }), _vm._v(" 生成名单")]) : _vm._e(), _vm._v(" "), (_vm.operateButtonVisible && _vm.graduateParam.standardType) ? _c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": _vm.showAddStuList
    }
  }, [_c('i', {
    staticClass: "el-icon-circle-plus-outline"
  }), _vm._v(" 添加")]) : _vm._e(), _vm._v(" "), (_vm.operateButtonVisible && _vm.graduateParam.standardType) ? _c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.submitRec
    }
  }, [_c('i', {
    staticClass: "el-icon-document-checked"
  }), _vm._v(" 提交")]) : _vm._e(), _vm._v(" "), (_vm.operateButtonVisible) ? _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.cantGraduateStu
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 不可毕业学生")]) : _vm._e(), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportStuList
    }
  }, [_c('i', {
    staticClass: "el-icon-download"
  }), _vm._v(" 导出")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "mainTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "element-loading-text": "信息加载中",
      "highlight-current-row": "",
      "border": "",
      "height": _vm.mainTableHeight
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s((_vm.currentPage - 1) * _vm.limit + scope.$index + 1))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学号",
      "prop": "stuCode",
      "align": "center",
      "width": "130px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "prop": "stuName",
      "align": "center",
      "width": "130px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "行政班名称",
      "prop": "className",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), (_vm.subjectFieldVisible) ? _c('el-table-column', {
    key: "1",
    attrs: {
      "label": "科目总数",
      "prop": "totalSubjectNum",
      "align": "center",
      "width": "100px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subjectFieldVisible) ? _c('el-table-column', {
    key: "2",
    attrs: {
      "label": "合格科目数",
      "prop": "subjectNum",
      "align": "center",
      "width": "100px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.subjectFieldVisible) ? _c('el-table-column', {
    key: "3",
    attrs: {
      "label": "合格率",
      "prop": "subjectRatio",
      "align": "center",
      "width": "100px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.creditFieldVisible) ? _c('el-table-column', {
    key: "4",
    attrs: {
      "label": "毕业要求学分",
      "prop": "totalCredit",
      "align": "center",
      "width": "110px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.creditFieldVisible) ? _c('el-table-column', {
    key: "5",
    attrs: {
      "label": "获得学分",
      "prop": "credit",
      "align": "center",
      "width": "110px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.creditFieldVisible) ? _c('el-table-column', {
    key: "6",
    attrs: {
      "label": "得分率",
      "prop": "creditRatio",
      "align": "center",
      "width": "100px"
    }
  }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "stuState",
      "align": "center",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "prop": "statusChange",
      "align": "center",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small",
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.showScoreList(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-tickets"
        }), _vm._v(" 成绩\n                ")]), _vm._v(" "), (_vm.operateButtonVisible) ? _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.delStuRec(scope.row);
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        }), _vm._v(" 删除\n                ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-container"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 20, 50],
      "page-size": _vm.limit,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-row', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auditAreaVisible),
      expression: "auditAreaVisible"
    }]
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('audit', {
    ref: "audit",
    attrs: {
      "itemCode": _vm.graduateParam.auditParam,
      "relatedCode": _vm.graduateParam.mainCode,
      "auditLevel": _vm.graduateParam.auditLevel
    },
    on: {
      "auditCallback": _vm.auditCallback
    }
  })], 1)], 1), _vm._v(" "), (_vm.dialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "毕业学生名单生成",
      "visible": _vm.dialogVisible,
      "width": "380px",
      "top": "300px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "250px"
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "120px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学年"
    }
  }, [_vm._v(_vm._s(_vm.graduateParam.year))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "毕业标准类型",
      "prop": "standardType"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.curdForm.standardType),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "standardType", $$v)
      },
      expression: "curdForm.standardType"
    }
  }, _vm._l((_vm.comboData.standardType), function(item) {
    return _c('el-radio-button', {
      key: item.comboValue,
      attrs: {
        "label": item.comboValue
      }
    }, [_vm._v(_vm._s(item.comboName))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "毕业标准（%）",
      "prop": "standardRatio"
    }
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "controls-position": "right",
      "precision": 1,
      "step": 0.1,
      "max": 100
    },
    model: {
      value: (_vm.curdForm.standardRatio),
      callback: function($$v) {
        _vm.$set(_vm.curdForm, "standardRatio", $$v)
      },
      expression: "curdForm.standardRatio"
    }
  }, [_c('i', {
    staticStyle: {
      "font-weight": "bold",
      "margin-right": "5px"
    },
    attrs: {
      "slot": "suffix"
    },
    slot: "suffix"
  }, [_vm._v("%")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin": "10px 0 10px 0"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.formSubmiting
    },
    on: {
      "click": _vm.createStuInfo
    }
  }, [_vm._v("生 成")])], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.graduateRequireDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "毕业要求  『 目前仅以总学分作为判断毕业标准 』",
      "visible": _vm.graduateRequireDialogVisible,
      "width": "1200px",
      "top": "80px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.graduateRequireDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "660px"
    }
  }, [_c('graduateRequire', {
    ref: "graduateRequire",
    attrs: {
      "graduateParam": _vm.graduateParam
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.addStuDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "添加",
      "visible": _vm.addStuDialogVisible,
      "width": "1100px",
      "top": "50px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.addStuDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "660px"
    }
  }, [_c('addStu', {
    ref: "addStu",
    attrs: {
      "graduateParam": _vm.graduateParam
    },
    on: {
      "closeAddStuDialog": _vm.closeAddStuDialog
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.scoreDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "科目成绩信息",
      "visible": _vm.scoreDialogVisible,
      "width": "900px",
      "top": "150px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.scoreDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "540px"
    }
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "scoreTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.scoreTableData,
      "element-loading-text": "信息加载中",
      "highlight-current-row": "",
      "border": "",
      "height": "500"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学年学期名称",
      "prop": "semesterName",
      "align": "center",
      "width": "200px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "课程名称",
      "prop": "courseName",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "成绩",
      "prop": "score",
      "align": "center",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学分",
      "prop": "credit",
      "align": "center",
      "width": "100px"
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.cantGraduateDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "不可毕业学生",
      "visible": _vm.cantGraduateDialogVisible,
      "width": "1400px",
      "top": "50px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.cantGraduateDialogVisible = $event
      }
    }
  }, [_c('div', {
    staticStyle: {
      "height": "700px"
    }
  }, [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.cantGraduateStu.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.cantGraduateForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.cantGraduateForm, "stuCode", $$v)
      },
      expression: "cantGraduateForm.stuCode"
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "行政班名称",
      "clearable": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.cantGraduateStu.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.cantGraduateForm.className),
      callback: function($$v) {
        _vm.$set(_vm.cantGraduateForm, "className", $$v)
      },
      expression: "cantGraduateForm.className"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.cantGraduateStu
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.cantGraduateHandleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.cantGraduateExport
    }
  }, [_c('i', {
    staticClass: "el-icon-download"
  }), _vm._v(" 导出")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.tableLoading),
      expression: "tableLoading",
      modifiers: {
        "body": true
      }
    }],
    ref: "cantGraduateTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.cantGraduateTableData,
      "element-loading-text": "信息加载中",
      "highlight-current-row": "",
      "border": "",
      "height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "序号",
      "width": "50",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.$index + 1))])]
      }
    }], null, false, 4178052834)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学号",
      "prop": "stuCode",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "prop": "stuName",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "行政班名称",
      "prop": "className",
      "align": "center",
      "min-width": "20%"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "毕业要求学分",
      "prop": "totalCredit",
      "align": "center",
      "width": "110px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "获得学分",
      "prop": "credit",
      "align": "center",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "得分率",
      "prop": "creditRatio",
      "align": "center",
      "width": "100px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "stuState",
      "align": "center",
      "width": "110px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "备注",
      "prop": "statusChange",
      "align": "center",
      "width": "100px"
    }
  })], 1)], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cf508ad"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/baseInfo/student/graduateStu.vue
// module id = 1874
// module chunks = 502